/**
 * CookieBanner — informational cookie notice (essential cookies only).
 *
 * Single acknowledge button, no categories: the app sets only strictly necessary
 * cookies, so there is nothing to opt out of. Hidden on gameplay routes, which are
 * fullscreen TV/phone views where an overlay would break the game display.
 */

import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import CookieConsent from "react-cookie-consent"

export function CookieBanner() {
  const { t } = useTranslation()
  const location = useLocation()

  if (location.pathname.startsWith("/game/")) return null

  return (
    <CookieConsent
      cookieName="giermek-cookie-consent"
      buttonText={t("cookies.accept")}
      expires={365}
      // Design tokens hold bare HSL channels (see src/index.css), so inline styles
      // have to wrap them the same way the Tailwind config does.
      style={{
        background: "hsl(var(--card))",
        borderTop: "1px solid hsl(var(--border))",
        color: "hsl(var(--foreground))",
        fontSize: "0.875rem",
        alignItems: "center",
      }}
      buttonStyle={{
        background: "hsl(var(--primary))",
        color: "hsl(var(--primary-foreground))",
        borderRadius: "0.5rem",
        padding: "0.5rem 1.25rem",
        fontSize: "0.875rem",
      }}
    >
      {t("cookies.message")}{" "}
      <Link to="/polityka-cookies" className="underline">
        {t("cookies.policyLink")}
      </Link>
    </CookieConsent>
  )
}
